<div mat-dialog-content>
    <mat-form-field appearance="fill" class="fullWidth">
        <mat-label>Please type <b>DELETE</b> to confirm</mat-label>
        <input matInput [(ngModel)]="delete"  (ngModelChange)="changeUpperCase(delete)" >
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-button class="primary" (click)="deleteShortUrl()" cdkFocusInitial  [disabled]="isDisabled">Ok</button>
    <button mat-button (click)="onNoClick()">Cancel</button> 
</div>